export const PUT_PROFILE_NEW  = 'PUT_PROFILE_NEW';
export const GET_PROFILE_NEW = 'GET_PROFILE_NEW';
export const OPEN_POPUP_FOLLOWER_FOLLOWING = 'OPEN_POPUP_FOLLOWER_FOLLOWING';

